module.exports = __webpack_public_path__ + "img/gzcj.e8a4a4d0.png";